if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

const initLenisSmoothScroll = () => {
  try {
    const lenis = new Lenis({
      prevent: (node) => {
        if (node === document.documentElement || node === document.body) return false;

        const style = getComputedStyle(node);
        const scrollableY = ['auto', 'scroll'].includes(style.overflowY) && node.scrollHeight > node.clientHeight;
        const scrollableX = ['auto', 'scroll'].includes(style.overflowX) && node.scrollWidth > node.clientWidth;

        return scrollableY || scrollableX;
      }
    });

    window.lenisInstance = lenis;

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  } catch (e) {
    console.error(e);
  }
};
initLenisSmoothScroll();

/* Shopify.Helpers — a collection of UI utilities:
 *   spinner   — show/hide loading spinners on any element or selector
 *   button    — lock/unlock (disable/enable) buttons
 *   message   — render inline status messages with optional auto-dismiss
 *   updateMarkupCart — re-fetch and re-render cart-icon-bubble and cart-drawer
 */
Shopify.Helpers = {
  spinner: {
    show: (trigger) => {
      const addSpiner = (container) => {
        if (container.querySelector('.spinner')) return;

        const spinnerHolderElement = document.createElement('span');
        spinnerHolderElement.classList.add('spinner-holder');

        const spinnerElement = document.createElement('span');
        spinnerElement.classList.add('spinner');

        spinnerHolderElement.append(spinnerElement);

        container.append(spinnerHolderElement);
        container.setAttribute('data-is-loading', '');
      };

      if (typeof (trigger) === 'string') {
        document.querySelectorAll(trigger).forEach(addSpiner);
      } else {
        addSpiner(trigger);
      }
    },

    hidden: (trigger) => {
      const removeSpiner = (container) => {
        container.querySelector('.spinner-holder')?.remove();
        container.removeAttribute('data-is-loading');
      };

      if (typeof (trigger) === 'string') {
        document.querySelectorAll(trigger).forEach(removeSpiner);
      } else {
        removeSpiner(trigger);
      }
    }
  },

  button: {
    lock: (element) => {
      element?.setAttribute('disabled', '');
    },

    unlock: (element) => {
      element?.removeAttribute('disabled');
    }
  },

  message: (element, { value, timer, status, additionalClassName, insertPosition = 'afterend' } = {}) => {
    /* How to use
    *
    * @param {Element|string} element  — target element or CSS selector | Required
    * @param {string}  value           — message text (HTML allowed)
    * @param {number}  [timer]         — auto-remove delay in ms
    * @param {string}  [status]        — 'success' | 'error' | 'warning'
    * @param {string}  [additionalClassName]
    * @param {string}  [insertPosition='afterend'] — insertAdjacentElement position
    *
    * @example
    * FormHelper.message('#email', { value: 'Invalid email', status: 'error', timer: 3000 });
    * FormHelper.message(inputEl,  { value: 'Saved!', status: 'success' });
    *
    * // Manual remove:
    * FormHelper.message(inputEl, { value: '' });
    * */

    const target = typeof (element) === 'string' ? document.querySelector(element) : element;
    if (!target) return;

    const existing = target.parentElement.querySelector('[data-role="message-holder"]');
    if (existing) existing.remove();

    if (!value) return;

    const dataStatus = {
      success: 'success',
      error: 'error',
      warning: 'warning'
    };

    const messageElement = document.createElement('span');
    messageElement.dataset.role = 'message-holder';
    messageElement.innerHTML = value;

    if (status && dataStatus[status]) {
      messageElement.dataset.messageStatus = dataStatus[status];
    }

    if (additionalClassName) {
      messageElement.classList.add(additionalClassName);
    }

    messageElement.style.opacity = '0';
    messageElement.style.transition = 'opacity 0.3s ease';

    target.insertAdjacentElement(insertPosition, messageElement);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        messageElement.style.opacity = '1';
      });
    });

    if (timer) {
      setTimeout(() => {
        messageElement.style.opacity = '0';
        messageElement.addEventListener('transitionend', () => messageElement.remove(), { once: true });
      }, timer);
    }
  },

  async updateMarkupCart() {
    // Fetches updated section HTML from Shopify and re-renders cart-icon-bubble and cart-drawer

    const response = await fetch('/?sections=cart-icon-bubble,cart-drawer');
    const sections = await response.json();

    const iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble && sections['cart-icon-bubble']) {
      iconBubble.innerHTML = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section').innerHTML;
    }

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && sections['cart-drawer']) {
      cartDrawer.innerHTML = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('cart-drawer').innerHTML;

      cartDrawer.classList.remove('is-empty');
    }

    cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => cartDrawer.close());
    cartDrawer.open();
  }
};

document.addEventListener('DOMContentLoaded', () => {

});